// Main-bundle styles for the composer entry points (kept tiny: they ship with every page load).

.button {
  // matches the other compose tool buttons (upload / poll / CW / emoji)
  line-height: 27px;
}

.hint {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 12px 0;
  padding: 6px 4px 6px 10px;
  border-radius: 8px;
  background: var(--color-bg-brand-softest);
  color: var(--color-text-secondary);
  font-size: 13px;
  line-height: 18px;
}

.hintText {
  flex: 1 1 auto;
  min-width: 0;
}

.hintAction {
  flex: 0 0 auto;
  padding: 2px 6px;
  border: 0;
  border-radius: 4px;
  background: none;
  color: var(--color-text-brand);
  font: inherit;
  font-weight: 600;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background: var(--color-bg-brand-soft);
  }
}

.hintClose {
  flex: 0 0 auto;
  display: flex;
  padding: 2px;
  border: 0;
  background: none;
  color: var(--color-text-tertiary);
  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;
    fill: currentcolor;
  }
}
